// extracted by mini-css-extract-plugin
export default {"callout":"v6xDMWWFGIgcB7k8Fb83"};